import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import md5 from 'md5';
import querystring from 'query-string';
import isRetina from 'is-retina';

// Source https://github.com/KyleAMathews/react-gravatar

class Gravatar extends Component {
    static displayName = 'Gravatar';

    render() {
        let base;
        if (this.props.https) {
            base = 'https://secure.gravatar.com/avatar/';
        } else {
            base = 'http://www.gravatar.com/avatar/';
        }

        const query = querystring.stringify({
            s: this.props.size,
            r: this.props.rating,
            d: this.props.default,
        });

        const retinaQuery = querystring.stringify({
            s: this.props.size * 2,
            r: this.props.rating,
            d: this.props.default,
        });

        let hash;
        if (this.props.md5) {
            hash = this.props.md5;
        } else if (this.props.email) {
            hash = md5(this.props.email);
        } else {
            // TODO Remove
            // console.warn(
            //   'Gravatar image can not be fetched. Either the "email" or "md5" prop must be specified.'
            // );
            return (<script />);
        }

        const src = `${base}${hash}?${query}`;
        const retinaSrc = `${base}${hash}?${retinaQuery}`;

        let modernBrowser = true; // server-side, we render for modern browsers

        if (typeof window !== 'undefined') {
            // this is not NodeJS
            modernBrowser = 'srcset' in document.createElement('img');
        }

        let className = 'react-gravatar';
        if (this.props.className) {
            className = `${className} ${this.props.className}`;
        }

        // Clone this.props and then delete Component specific props so we can
        // spread the rest into the img.
        const { ...rest } = this.props;
        delete rest.https;
        delete rest.md5;
        delete rest.email;
        delete rest.rating;
        delete rest.size;
        delete rest.style;
        delete rest.className;
        delete rest.default;
        if (!modernBrowser && isRetina()) {
            return (
                <img
                    alt={`Gravatar for ${this.props.email}`}
                    style={this.props.style}
                    src={retinaSrc}
                    height={this.props.size}
                    width={this.props.size}
                    {...rest}
                    className={className}
                />
            );
        }
        return (
            <img
                alt={`Gravatar for ${this.props.email}`}
                style={this.props.style}
                src={src}
                srcSet={`${retinaSrc} 2x`}
                height={this.props.size}
                width={this.props.size}
                {...rest}
                className={className}
            />
        );
    }
}

Gravatar.propTypes = {
    email: PropTypes.string.isRequired,
    md5: PropTypes.string,
    size: PropTypes.number,
    rating: PropTypes.string,
    https: PropTypes.bool,
    default: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
};

Gravatar.defaultProps = {
    size: 50,
    rating: 'g',
    https: true,
    default: 'retro',
    md5: null,
    className: null,
    style: null,
};

export default injectIntl(Gravatar);
